// src/catalog/components/detail/CatalogEntryProgramLocaleSelector.jsx

import { useProgramScopedLocale } from "../../../features/program-localization/ProgramScopedLocaleContext";
import { ApplicationOptionSelector } from "../../../components/application";

export default function CatalogEntryProgramLocaleSelector({
  disabled = false,
  id = "catalog-program-locale"
}) {
  const {
    isEnabled,
    activeLocale,
    supportedLocaleOptions,
    setLocale,
    translate
  } = useProgramScopedLocale();

  if (!isEnabled || supportedLocaleOptions.length <= 1) {
    return null;
  }

  return (
    <ApplicationOptionSelector
      id={id}
      label={translate("program_language", "Program language")}
      value={activeLocale}
      disabled={disabled}
      onChange={setLocale}
      options={supportedLocaleOptions.map((option) => ({
        value: option.locale,
        label: translate(option.labelKey, option.label)
      }))}
    />
  );
}
